import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
// oxlint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import { xcss } from '@atlaskit/primitives/xcss';

type SidePanelFooterProps = {
	children: React.ReactNode;
};

const footerBaseStyles = xcss({
	borderTopColor: 'color.border',
	borderTopStyle: 'solid',
	borderTopWidth: 'border.width',
});

export const SidePanelFooter = ({ children }: SidePanelFooterProps): React.JSX.Element => {
	return (
		<Box paddingBlock="space.200" paddingInline="space.300" xcss={footerBaseStyles}>
			{children}
		</Box>
	);
};
